import PropTypes from 'prop-types'
import { createContext, useState } from 'react'

export const UsuarioContext = createContext()
UsuarioContext.displayName = 'UsuarioContext'

export const UsuarioProvider = (props) => {
  const [autenticado, setAutenticado] = useState([])
  const [imagenModif, setImagenModif] = useState([])

  return (
    <UsuarioContext.Provider
      value={{ autenticado, imagenModif, setAutenticado, setImagenModif }}
    >
      {props.children}
    </UsuarioContext.Provider>
  )
}

UsuarioProvider.propTypes = {
  children: PropTypes.node.isRequired
}
